import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/**
 * Helper to get authorization headers with Bearer token
 */
const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token') || localStorage.getItem('adminToken');
    return {
        'accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

/**
 * Fetch host details (Admin API)
 * Endpoint: /users/admin/host-details
 * Example: /users/admin/host-details?page=1&limit=10&search=ayurveda&status=active&location=kerala&kyc=verified&slab=...
 */
export const getAdminHostDetails = async (params = {}) => {
    try {
        const filteredParams = { ...params };
        if (filteredParams.limit === 10) {
            delete filteredParams.limit;
        }
        const response = await axios.get(`${apiUrlOne}/users/admin/host-details`, {
            params: filteredParams,
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching host details:", error);
        throw error;
    }
};

const hostApi = {
    getAdminHostDetails
};

export default hostApi;
